module.exports = __webpack_public_path__ + "img/Layer_1.f0ead24b.png";